import * as actionTypes from '../../actions/jobScreening/actionTypes';

export const initialState = {
  jobs: [],
  isLoading: true
};

const jobReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_JOBSCREENING_JOBS:
      return {
        ...state,
        isLoading: false,
        jobs: action.data
      };
    case actionTypes.SET_JOBSCREENING_LOADING:
      return {
        ...state,
        isLoading: true
      };
    default:
      return state;
  }
};

export default jobReducer;
